<template>
    <div class="fluid">
        <h1 class="app-title">CADASTRO DE TERMO DE REGULARIZAÇÃO PARA PARCELAMENTO - TRP</h1>
        <b-card>
            <b-row class="mb-0">
                <b-col sm="12" md="4" class="mb-0">
                    <b-form-group
                            label="Nome:"
                            label-for="nome"
                            class="text-label required">
                        <b-form-input v-model="tipoTrp.descricao" type="text" id="nome" maxlength="250"
                                      :disabled="true"/>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2" class="mb-0">
                    <p>
                        Situação:
                        <span class="text-danger">*</span>
                    </p>
                    <b-form-group label>
                        <b-form-radio-group
                                id="radio-group-9"
                                v-model="tipoTrp.indAtivo"
                                name="radio-situacao"
                                :disabled="true">
                            <b-form-radio value="true">Ativo</b-form-radio>
                            <b-form-radio value="false">Inativo</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2" class="mt-3">
                    <label></label>
                    <b-form-group id="input-group" label label-for="refis">
                        <b-form-checkbox v-model="tipoTrp.refis" id="refis" name="check-button" switch
                                         :disabled="true">
                            Refis
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col sm="2" md="4" v-if="tipoTrp.refis">
                    <b-form-group
                            label="Associar a uma regra REFIS ativa no sistema:"
                            label-for="pagamento"
                            class="text-label required"
                            :disabled="true">
                        <b-form-select v-model="tipoTrp.codPagamento" class="mb-3"
                                       :disabled="true">
                            <template v-slot:first>
                                <option :value="null">Selecionar</option>
                            </template>
                            <option
                                    v-for="tc in dados.regraPagamento"
                                    :key="tc.id"
                                    :value="tc.id">
                                {{ tc.nome }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row class="mb-0" style="margin-top: 10px;">
                <b-col sm="12" md="6">
                    <div>
                        <label class="typo__label">
                            Tipos de Crédito a que se aplica o TRP:
                        </label>
                        <multiselect
                                v-model="tipoTrp.listaTipoCredito"
                                tag-placeholder
                                placeholder="Selecionar uma ou mais opções"
                                label="nome"
                                track-by="id"
                                :disabled="true"
                                :options="dados.tiposCredito"
                                :multiple="true"
                                :taggable="true">
                        </multiselect>
                    </div>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group
                            label="Prazo de validade do TRP (em dias corridos):"
                            label-for="prazo"
                            class="text-label required">
                        <b-form-input
                                ref="prazo"
                                type="text"
                                id="prazo"
                                :disabled="true"
                                v-model="tipoTrp.prazoValidade"
                                v-mask="['#########']"
                                description="Somente os números"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row class="mb-0" style="margin-top: 10px;">
                <b-col sm="12" md="6">
                    <label></label>
                    <b-form-group label label-for="exigeRequisicao">
                        <b-form-checkbox v-model="tipoTrp.exigeRequisicao" id="exigeRequisicao" name="check-button"
                                         :disabled="true">
                            A emissão exige <strong>Requisição</strong> emitida no status <span class="text-primary">Quitada</span> ou <span class="text-warning">Em dia</span> para as CDA's ajuizadas até 17/03/2016
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group
                            label="Texto do TRP (se selecionada a checkbox à esquerda):"
                            class="text-label">
                        <b-form-input
                                type="text"
                                v-model="tipoTrp.descricaoRequisicao"
                                :disabled="true"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row class="mb-0" style="margin-top: 10px;">
                <b-col sm="12" md="6">
                    <label></label>
                    <b-form-group label label-for="exigeDesistencia">
                        <b-form-checkbox v-model="tipoTrp.exigeDesistencia" id="exigeDesistencia" name="check-button"
                                         :disabled="true">
                            A emissão exige <strong>Registro de Desistência</strong> de eventuais ações ou embargos à execução fiscal com renúncia ao direito sobre o qual se fundam, e de impugnações, defesas e recursos administrativos
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group
                            label="Texto do TRP (se selecionada a checkbox à esquerda):"
                            class="text-label">
                        <b-form-input
                                type="text"
                                v-model="tipoTrp.descricaoDesistencia"
                                :disabled="true"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row class="mb-0" style="margin-top: 10px;">
                <b-col sm="12" md="6">
                    <label></label>
                    <b-form-group label label-for="exigePagamento">
                        <b-form-checkbox v-model="tipoTrp.exigePagamento" id="exigePagamento" name="check-button"
                                         :disabled="true">
                            A emissão exige a comprovação do <strong>Pagamento de Custas Judiciais</strong>
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group
                            label="Texto do TRP (se selecionada a checkbox à esquerda):"
                            class="text-label">
                        <b-form-input
                                type="text"
                                v-model="tipoTrp.descricaoPagamento"
                                :disabled="true"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row class="mb-0" style="margin-top: 10px;">
                <b-col sm="12" md="6">
                    <label></label>
                    <b-form-group label label-for="exigeGarantia">
                        <b-form-checkbox v-model="tipoTrp.exigeGarantia" id="exigeGarantia" name="check-button"
                                         :disabled="true">
                            A emissão exige <strong>Garantia</strong> do débito principal
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group
                            label="Texto do TRP (se selecionada a checkbox à esquerda):"
                            class="text-label">
                        <b-form-input
                                type="text"
                                v-model="tipoTrp.descricaoGarantia"
                                :disabled="true"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row style="margin-top: 10px;">
                <b-col sm="12" md="4">
                    <p class="mb-2">
                        Somente a partir do valor (R$):
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           v-b-modal.modal-info-valor></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="tipoTrp.valorMinimo" type="text" id="valorMinimo"
                                      @keyup="tipoTrp.valorMinimo = formatarMonetario(tipoTrp.valorMinimo)"
                                      :disabled="true"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card>

        <b-modal
                ref="modal-info-valor"
                id="modal-info-valor"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Valor mínimo a exigir garantia"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            <p>Caso a garantia somente seja exigida a débitos que ultrapassem um determinado valor, preencha no campo abaixo o referido valor. A partir de quanto passa a ser exigida a garantia.</p>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-valor')"> Fechar</b-button>
            </template>
        </b-modal>

        <hr class="mt-2"/>
        <b-row class="center-xy">
            <b-button variant="outline-secondary" @click="voltar()">
                <i class="fa fa-reply"></i> Voltar
            </b-button>
        </b-row>
        <CompLoading ref="loading"/>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import axios from 'axios'
    import CompLoading from "../shared/components/CompLoading";
    import formatarMixins from '../../mixins/formatarMixins';

    export default {
        components: {CompLoading, Multiselect},
        mixins: [ formatarMixins ],
        data() {
            return {
                urlApi: null,
                token: null,
                tipoTrp: {
                    codTipoTrp: null,
                    descricao: null,
                    indAtivo: null,
                    refis: null,
                    prazoValidade: null,
                    exigeRequisicao: null,
                    exigeDesistencia: null,
                    exigePagamento: null,
                    exigeGarantia: null,
                    descricaoRequisicao: null,
                    descricaoDesistencia: null,
                    descricaoPagamento: null,
                    descricaoGarantia: null,
                    valorMinimo: null,
                    codPagamento: null,
                    listaTipoCredito: null,
                },
                dados: {
                    tiposCredito: [],
                    regraPagamento: []
                },
            }
        },
        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            }
        },
        methods: {
            async listarTiposCredito() {
                axios.get(`${this.urlApi}/v1/regrasPagamento/listarTiposCredito`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.dados.tiposCredito = response.data
                })
            },
            async listarRegrasPagamento() {
                axios.get(`${this.urlApi}/v1/tipoTrp/listarRegrasPagamento`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.dados.regraPagamento = response.data
                })
            },

            voltar() {
                this.$router.push({path: '/tipo-trp'});
            },

            async obterTipoTrp(codTipoTrp) {
                await axios.get(`${this.urlApi}/v1/tipoTrp/` + codTipoTrp, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.tipoTrp = {
                        ...response.data,
                        valorMinimo: this.formatarMonetarioExibir(response.data.valorMinimo, 7, 2),
                    };
                }).catch((error) => {
                    this.exibirErro(error)
                })
            },
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            let tipoTrpEditado = this.$store.getters.getTipoTrp;
            if(tipoTrpEditado) {
                this.$store.commit('setTipoTrp', null);
                this.obterTipoTrp(tipoTrpEditado);
            }

            this.listarRegrasPagamento();
            this.listarTiposCredito();
        }
    }
</script>
